import React from 'react';

const LOGO_SRC = '/logo.png';

const BrandSeal = ({ compact = false, className = '' }) => {
  const sizeClass = compact ? 'h-12 w-12 sm:h-14 sm:w-14' : 'h-24 w-24 sm:h-28 sm:w-28';

  return (
    <div className={`inline-flex items-center justify-center ${sizeClass} ${className}`}>
      <img
        src={LOGO_SRC}
        alt="Panchami Jewellery"
        className="h-full w-full object-contain mix-blend-lighten drop-shadow-[0_6px_16px_rgba(12,4,2,0.35)]"
      />
    </div>
  );
};

export default BrandSeal;
